
/**
 * @description
 * 홈 > 학습 > 학년별 교육과정 아이템
 */

import { CLICK_GRADE_EDUCATION } from '@/utils/amplitudeEvent/amplitudeEvents.js';

export default {
  name: 'GradeItem',
  props: {
    title: { type: String, default: null },
    slug: { type: String, default: null },
    icon: { type: String, default: null },
  },
  methods: {
    logClickGradeItem() {
      this.logUserCustomEvent(CLICK_GRADE_EDUCATION, {
        grade: this.title.replace('<br>', ' '),
      });
    },
  },
};
